import { useMutation, useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { showToast } from "../../helper/ShowToast";
import { createMixAnalysisReport, getMixAnalysisReport, updateMixAnalysisReport } from "../../api/urstudio/mixanalyst.api";
import { useDispatch } from "react-redux";
import { consumeCredits, getCreditDetails } from "../../redux/actions";
import { completeProcess, failProcess, consumePendingRewardNotifications } from "../../redux/actions/backgroundProcesses";
import { setMixReportId } from "../../redux/actions/audioEngineer";
import { getUrStudioQueryScope } from "./urstudioScope";

export const useCreateMixAnalysisReport = () => {
  const dispatch = useDispatch()
  return useMutation({
    mutationFn: ({ processId, ...body }) => createMixAnalysisReport(body),
    onSuccess: (data, variables) => {
      dispatch(consumeCredits(3));
      dispatch(setMixReportId(data?.data?._id))
      dispatch(completeProcess(variables.processId))
      if (data?.milestonesReached?.length) {
        dispatch(consumePendingRewardNotifications(data.milestonesReached));
      }
      // showToast("success", "Mix Analysis report generated");
    },
    onError: (err, variables) =>{
      showToast(
        "error",
        err?.response?.data?.message || "Failed to generate mix analysis report"
      )
      dispatch(failProcess(variables.processId, err?.message || "Mix analysis failed"));
    }
  });
};

export const useCreateMixAnalysisReportForNonSub = () => {
  return useMutation({
    mutationFn: (body) => createMixAnalysisReport(body),
    onSuccess: () => {
      showToast("success", "Mix Analysis report generated");
    },
    onError: (err) =>
      showToast(
        "error",
        err?.response?.data?.message || "Failed to generate mix analysis report"
      ),
  });
};

export const useUpdateMixAnalysisReport = () => {
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: (body) => updateMixAnalysisReport(body),
    onSuccess: (data) => {
      showToast("success", "Mix Analysis report generated");
      // This call may complete the "First Mix"/"Studio Regular" rewards and
      // credit AI credits server-side before responding — refresh the
      // sidebar balance immediately.
      dispatch(getCreditDetails());
      if (data?.milestonesReached?.length) {
        dispatch(consumePendingRewardNotifications(data.milestonesReached));
      }
    },
    onError: (err) =>
      showToast(
        "error",
        err?.response?.data?.message || "Failed to generate mix analysis report"
      ),
  });
};

export const useMixAnalysisReportByTrack = (id) => {
  const access = useSelector((state) => state.auth?.access);
  const scope = getUrStudioQueryScope(access);

  return useQuery({
    queryKey: ['mixAnalysisReport', scope, id],
    queryFn: () => getMixAnalysisReport(id),
    enabled: !!id,  // only runs when id is available
    onError: (err) =>
      showToast(
        "error",
        err?.response?.data?.message || "Failed to fetch mix analysis report"
      ),
  });
}
